// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"styles_mainContainer__3-bqn","pageContentWrapper":"styles_pageContentWrapper__25QB4"};